import './styles/style.scss';
import UIModuleCalc from './components/calc.svelte';
import UICommon from '../common';
import { ONE_MODULE_PRINT, SIZE_MAX, SIZE_MIN, PRICE_OFF, DEFAULT_PICTURE_DIMENSION_RATE, DEFAULT_SIZE_WIDTH, DEFAULT_SIZE_HEIGHT, PROJECT_SIZE_MAX } from '../const';
import { loadModules } from '../api';
class nmModuleCalcUI {
    #materialSizes;
    #constraints;
    // #sizeStep: number = 1;
    #modulesVariant = JSON.parse(JSON.stringify(ONE_MODULE_PRINT));
    #ui;
    #picture;
    calculator;
    project;
    constructor(targetId, calculator, project) {
        this.project = project;
        this.calculator = calculator;
        const targetEl = document.getElementById(targetId);
        if (targetEl) {
            this.init(targetEl).catch(e => console.error(e));
        }
        else {
            throw Error('No target element for CalculatorModulesUI');
        }
        return this;
    }
    getPriceOff() {
        const priceoff = this.calculator.getDiscount();
        if (isNaN(priceoff) || (priceoff === 0)) {
            return PRICE_OFF;
        }
        else {
            return priceoff;
        }
    }
    async init(target) {
        const MODULES = await loadModules();
        this.project.on('imageChanged', (e) => this.onImageChanged(e));
        this.project.on('total.changed', (e) => this.onTotalChanged(e));
        this.#ui = new UIModuleCalc({ target, props: {
                MODULES,
                selectedModule: undefined,
                pictureDimensionsRate: DEFAULT_PICTURE_DIMENSION_RATE
            } });
        this.#ui.$on('sizeChange', ({ detail }) => {
            this.onSizeChange(parseInt(detail));
        });
        this.#ui.$on('heightChange', ({ detail }) => {
            this.onHeightChange(parseInt(detail));
        });
        this.#ui.$on('widthChange', ({ detail }) => {
            this.onWidthChange(parseInt(detail));
        });
        this.#ui.$on('pictureCached', ({ detail }) => {
            this.onPictureCached(detail);
        });
        this.#ui.$on('moduleChange', ({ detail }) => {
            this.onModuleChange(detail);
        });
    }
    onImageChanged(picture) {
        this.#ui.$set({ picture });
    }
    onTotalChanged(price) {
        this.#ui.$set({
            totalPriceOriginal: UICommon.formatPrice(Math.round(price / ((100 - this.getPriceOff()) / 100))),
            totalPriceWithDiscount: UICommon.formatPrice(price)
        });
    }
    updateMaterialSizes(rate) {
        if (this.#constraints) {
            const ratio = this.getPictureRatio();
            const width = this.#constraints.min.width + (this.#constraints.max.width - this.#constraints.min.width) / 100 * rate;
            this.#materialSizes = {
                width: Math.ceil(width),
                height: Math.ceil(ratio > 1 ? width / ratio : width * ratio)
            };
            console.log('material sizes', this.#materialSizes);
        }
        else {
            this.#materialSizes = {
                width: DEFAULT_SIZE_WIDTH,
                height: DEFAULT_SIZE_HEIGHT
            };
        }
    }
    onSizeChange(rate) {
        console.log('change size in UI');
        this.updateSizeStep();
        this.updateMaterialSizes(rate);
        this.#ui.$set({ dimensionWidth: this.#materialSizes.width, dimensionHeight: this.#materialSizes.height });
        this.project.changeSize(this.#materialSizes);
    }
    setSizeRateInUI(rate) {
        this.#ui.$set({ pictureDimensionsRate: rate });
    }
    onWidthChange(width) {
        console.log('try set width =', width);
        if (this.#constraints) {
            if (this.#constraints.min.width <= width && this.#constraints.max.width >= width) {
                let rate = (width - this.#constraints.min.width) / ((this.#constraints.max.width - this.#constraints.min.width)) * 100;
                this.#ui.$set({ pictureDimensionsRate: rate });
                this.onSizeChange(rate);
            }
            else {
                if (this.#constraints.min.width > width) {
                    this.onWidthChange(this.#constraints.min.width);
                }
                else if (this.#constraints.max.width < width) {
                    this.onWidthChange(this.#constraints.max.width);
                }
            }
        }
    }
    onHeightChange(height) {
        console.log('try set height =', height);
        if (this.#constraints) {
            if (this.#constraints.min.height <= height && this.#constraints.max.height >= height) {
                const ratio = this.getPictureRatio();
                this.onWidthChange(height * ratio);
            }
        }
    }
    onPictureCached(cachedPicture) {
        this.#picture = cachedPicture;
        this.updateSizeStep();
        this.setSizeRateInUI(DEFAULT_PICTURE_DIMENSION_RATE);
        this.onSizeChange(DEFAULT_PICTURE_DIMENSION_RATE);
    }
    getPictureRatio() {
        if (this.#picture) {
            return this.#picture.naturalWidth / this.#picture.naturalHeight;
        }
        else {
            return 1;
        }
    }
    onModuleChange(modulesVariant) {
        console.log(modulesVariant);
        this.#modulesVariant = modulesVariant;
        this.project.changeModulesFormat(modulesVariant);
        this.updateSizeStep();
        this.setSizeRateInUI(DEFAULT_PICTURE_DIMENSION_RATE);
        this.onSizeChange(DEFAULT_PICTURE_DIMENSION_RATE);
    }
    checkMaxProjectHeightContraint(size) {
        if (this.#constraints.max.height > PROJECT_SIZE_MAX) {
            this.#constraints.max.width = this.#constraints.max.width * (PROJECT_SIZE_MAX / this.#constraints.max.height);
            this.#constraints.max.height = PROJECT_SIZE_MAX;
        }
    }
    updateSizeStep() {
        if (!this.#modulesVariant)
            return;
        const ratio = this.getPictureRatio();
        let minShortEdge = 10000, maxShortEdge = 0; //distorted
        this.#modulesVariant.value.forEach((moduleVariant) => {
            const width = parseFloat(moduleVariant.width) * ratio, height = parseFloat(moduleVariant.height);
            const shortEdge = Math.min(width, height);
            minShortEdge = Math.min(minShortEdge, shortEdge);
            maxShortEdge = Math.max(maxShortEdge, shortEdge);
        });
        const minPercent = SIZE_MIN / minShortEdge;
        const maxPercent = SIZE_MAX / maxShortEdge;
        this.#constraints = {
            min: {
                width: ratio * 100 * minPercent,
                height: 100 * minPercent,
                //step: minPercent
            },
            max: {
                width: ratio * 100 * maxPercent,
                height: 100 * maxPercent,
                //step: maxPercent
            }
        };
        this.checkMaxProjectHeightContraint(this.#constraints.max);
        this.#ui.$set({ pictureDimensionsConstraints: this.#constraints });
    }
    updateSizeStep_old() {
        if (!this.#modulesVariant)
            return;
        const ratio = this.getPictureRatio();
        let maxBlockDimensions = { width: 0, height: 0, refEdge: 0, step: 0 };
        let minBlockDimensions = { width: 10000, height: 10000, refEdge: 10000, step: 10000 };
        this.#materialSizes && console.log(`material sizes width: ${this.#materialSizes.width}, height = ${this.#materialSizes.height}`);
        this.#modulesVariant.value.forEach((moduleVariant) => {
            //in % of material size
            const width = parseFloat(moduleVariant.width), height = parseFloat(moduleVariant.height);
            //dimension units in ratio
            const [widthWithRatio, heightWithRatio] = ratio > 1 ? [width, height / ratio] : [width * ratio, height];
            this.#materialSizes &&
                console.log('module', `${moduleVariant.id}, WR = ${widthWithRatio} X HR = ${heightWithRatio}, ${width}% [${(this.#materialSizes.width * width / 100).toFixed(2)}cm], ${height}% [${(height * this.#materialSizes.height / 100).toFixed(2)}cm]`);
            //
            const minDimWithRatio = Math.min(widthWithRatio, heightWithRatio);
            if (minBlockDimensions.refEdge > minDimWithRatio) {
                let oneStep = (widthWithRatio > heightWithRatio) ? SIZE_MIN / heightWithRatio : SIZE_MIN / widthWithRatio;
                const size = {
                    width: Math.ceil(widthWithRatio * oneStep / width * 100),
                    height: Math.ceil(heightWithRatio * oneStep / height * 100),
                    step: oneStep
                };
                minBlockDimensions = { ...minBlockDimensions, ...size };
                minBlockDimensions.refEdge = minDimWithRatio;
            }
            //
            const maxDimWithRatio = Math.min(widthWithRatio, heightWithRatio);
            if (maxBlockDimensions.refEdge < maxDimWithRatio) {
                let oneStep = (widthWithRatio > heightWithRatio) ? SIZE_MAX / widthWithRatio : SIZE_MAX / heightWithRatio;
                const size = {
                    width: Math.ceil(widthWithRatio * oneStep / width * 100),
                    height: Math.ceil(heightWithRatio * oneStep / height * 100),
                    step: oneStep
                };
                maxBlockDimensions = { ...maxBlockDimensions, ...size };
                maxBlockDimensions.refEdge = maxDimWithRatio;
            }
        });
        this.#constraints = {
            min: minBlockDimensions,
            max: maxBlockDimensions
        };
        this.#ui.$set({ pictureDimensionsConstraints: this.#constraints });
    }
    updateUIFromSummary() { }
    render() { }
}
export default nmModuleCalcUI;
